import SearchNoContent from './searchNoContent';

export default SearchNoContent;
